/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Source of nested cash-account data on portfolio read APIs.
 * PCO loads cash accounts from the local PCO database (default).
 * CRMCH loads cash accounts from CRN Integrator (CRM-CH) and maps them onto PCO portfolios by portfolio number.
 * 
 * @export
 */
export const CashAccountSource = {
    Pco: 'PCO',
    Crmch: 'CRMCH'
} as const;
export type CashAccountSource = typeof CashAccountSource[keyof typeof CashAccountSource];


export function instanceOfCashAccountSource(value: any): boolean {
    for (const key in CashAccountSource) {
        if (Object.prototype.hasOwnProperty.call(CashAccountSource, key)) {
            if (CashAccountSource[key as keyof typeof CashAccountSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CashAccountSourceFromJSON(json: any): CashAccountSource {
    return CashAccountSourceFromJSONTyped(json, false);
}

export function CashAccountSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CashAccountSource {
    return json as CashAccountSource;
}

export function CashAccountSourceToJSON(value?: CashAccountSource | null): any {
    return value as any;
}

export function CashAccountSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): CashAccountSource {
    return value as CashAccountSource;
}

